import { render, staticRenderFns } from "./performance-options.vue?vue&type=template&id=a975c532&scoped=true&"
import script from "./performance-options.vue?vue&type=script&lang=js&"
export * from "./performance-options.vue?vue&type=script&lang=js&"
import style0 from "./performance-options.vue?vue&type=style&index=0&id=a975c532&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a975c532",
  null
  
)

export default component.exports